import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { Dropdown } from 'antd';
import {
  MenuOutlined,
  UserOutlined,
  SettingOutlined,
  QuestionCircleOutlined,
  LogoutOutlined,
  DownOutlined,
} from '@ant-design/icons';
import { authLogout } from '../../../applications/auth/redux/reducer/actions';

const AppHeader = ({ user, pageTitle, breadcrumb, onMenuToggle }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const handleLogout = () => {
    dispatch(authLogout());
    history.push('/auth');
  };

  const getPageTitle = () => {
    if (pageTitle) return pageTitle;

    const pathMap = {
      '/': 'Home',
      '/yd-monitoring': 'YD Monitoring System',
      '/saatm-dashboard': 'SAATM Dashboard',
      '/administration': 'Admin Dashboard',
      '/profile': 'Profile Settings',
      '/help': 'Help & Support',
      '/e-library': 'YD Regulations',
      '/definitions': 'Definitions',
      '/documents': 'Documents',
      '/reports': 'Reports',
      '/contact': 'Contact',
    };

    return pathMap[location.pathname] || 'Dashboard';
  };

  const getBreadcrumb = () => {
    if (breadcrumb) return breadcrumb;

    const pathParts = location.pathname.split('/').filter(Boolean);
    if (pathParts.length === 0) return null;

    return pathParts.map((part, index) => ({
      label: part.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
      path: '/' + pathParts.slice(0, index + 1).join('/'),
      current: index === pathParts.length - 1,
    }));
  };

  const getUserInitials = () => {
    if (!user?.short_name) return 'U';
    const names = user.short_name.split(' ');
    if (names.length >= 2) {
      return `${names[0][0]}${names[1][0]}`.toUpperCase();
    }
    return user.short_name.substring(0, 2).toUpperCase();
  };

  const userMenuItems = {
    items: [
      {
        key: 'profile',
        icon: <UserOutlined />,
        label: 'My Profile',
        onClick: () => history.push('/profile'),
      },
      {
        key: 'settings',
        icon: <SettingOutlined />,
        label: 'Settings',
        onClick: () => history.push('/profile'),
      },
      {
        key: 'help',
        icon: <QuestionCircleOutlined />,
        label: 'Help & Support',
        onClick: () => history.push('/help'),
      },
      {
        type: 'divider',
      },
      {
        key: 'logout',
        icon: <LogoutOutlined />,
        label: 'Sign Out',
        danger: true,
        onClick: handleLogout,
      },
    ],
  };

  const breadcrumbItems = getBreadcrumb();

  return (
    <header className="header">
      {/* Left section */}
      <div className="header-left">
        <button className="header-menu-toggle" onClick={onMenuToggle}>
          <MenuOutlined />
        </button>
        <div className="header-title">
          <h1>{getPageTitle()}</h1>
          {breadcrumbItems && breadcrumbItems.length > 0 && (
            <nav className="header-breadcrumb">
              <a href="/">Home</a>
              {breadcrumbItems.map((item, index) => (
                <React.Fragment key={item.path}>
                  <span className="separator">/</span>
                  {item.current ? (
                    <span className="current">{item.label}</span>
                  ) : (
                    <a href={item.path}>{item.label}</a>
                  )}
                </React.Fragment>
              ))}
            </nav>
          )}
        </div>
      </div>

      {/* Right section */}
      <div className="header-right">
        {/* User dropdown */}
        <Dropdown menu={userMenuItems} trigger={['click']} placement="bottomRight">
          <div className="header-user" role="button" tabIndex={0}>
            <div className="header-user-avatar">
              {getUserInitials()}
            </div>
            <div className="header-user-info">
              <div className="user-name">{user?.short_name || 'User'}</div>
              <div className="user-role">{user?.role || 'Member'}</div>
            </div>
            <DownOutlined className="header-user-chevron" />
          </div>
        </Dropdown>
      </div>
    </header>
  );
};

const mapStateToProps = ({ AuthReducer }) => ({
  user: AuthReducer.user,
});

export default connect(mapStateToProps)(AppHeader);
